



















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AssetClass2, AssetClassesApi } from 'performo-api';
import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  computed: mapGetters({
    api: 'assetClassesApi'
  })
})
export default class AssetClass2Picker extends Vue {
  @Prop({ required: false, default: 'asset-class-2-picker' })
  private id?: string;

  @Prop({ required: false, default: false, type: Boolean })
  private required?: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  private hideAll?: boolean;

  @Prop({ required: false, default: false, type: Boolean })
  private hideLabel?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: false, default: 'Category' })
  private labelOverride?: string;

  @Prop({ required: false, default: undefined })
  private assetClass1?: string;

  get getValue() {
    return this.value;
  }

  get sortedClasses() {
    return this.classes.sort((a, b) => {
      if (!a.assetClass2Name || !b.assetClass2Name) return 0;
      var nameA = a.assetClass2Name.toUpperCase(); // ignore upper and lowercase
      var nameB = b.assetClass2Name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    });
  }

  private api!: AssetClassesApi;
  private classes: AssetClass2[] = [];
  private loadingClasses = false;
  private hasMounted = false;

  @Watch('assetClass1')
  private async loadClasses() {
    if (this.hasMounted) {
      this.$emit('input', undefined);
    }
    if (this.assetClass1 && this.assetClass1 != '*') {
      this.loadingClasses = true;
      try {
        this.classes = await this.api.assetClass2Query({
          assetClass1Name: this.assetClass1
        });
        this.loadingClasses = false;
        return this.classes;
      } catch (error) {
        this.loadingClasses = false;
        return handleApiError(error);
      }
    } else {
      this.classes = [];
    }
  }

  private async mounted() {
    await this.loadClasses();
    this.hasMounted = true;
  }
}
